import { Navigate } from "src/router";
import type { RouteObject } from "src/router";
import { RedirectWithWildcard } from "src/components/router/redirect-with-wildcard";
import { lazyNamed } from "src/utils/lazy-named";

const CreateAudienceObject = lazyNamed(
  () => import("src/pages/audiences/setup/create-object"),
  "CreateAudienceObject",
);
const AudienceObject = lazyNamed(
  () => import("src/pages/audiences/setup/object"),
  "AudienceObject",
);
const AudienceObjectQuery = lazyNamed(
  () => import("src/pages/audiences/setup/object-query"),
  "AudienceObjectQuery",
);
const SetupAudiences = lazyNamed(
  () => import("src/pages/audiences/setup/setup-audiences"),
  "SetupAudiences",
);
const SchemaPage = lazyNamed(() => import("./index"), "SchemaPage");
const ParentModels = lazyNamed(
  () => import("src/pages/audiences/setup/parent-models"),
  "ParentModels",
);
const RelatedModels = lazyNamed(
  () => import("src/pages/audiences/setup/related-models"),
  "RelatedModels",
);
const EventModels = lazyNamed(
  () => import("src/pages/audiences/setup/event-models"),
  "EventModels",
);

export const routes: Array<RouteObject> = [
  {
    path: "schema/:object/:id/query",
    spacesAccess: "hidden-from-limited-view",
    element: <AudienceObjectQuery />,
  },
  {
    path: "schema/:object/new",
    spacesAccess: "hidden-from-limited-view",
    element: <CreateAudienceObject />,
  },
  {
    path: "schema/:object/:id",
    spacesAccess: "hidden-from-limited-view",
    element: <AudienceObject />,
  },
  {
    path: "schema/*",
    spacesAccess: "hidden-from-limited-view",
    element: <SetupAudiences />,
    children: [
      {
        index: true,
        spacesAccess: "hidden-from-limited-view",
        element: <Navigate to="parent-models" replace />,
      },
      {
        path: "parent-models",
        spacesAccess: "hidden-from-limited-view",
        element: <ParentModels />,
      },
      {
        path: "related-models",
        spacesAccess: "hidden-from-limited-view",
        element: <RelatedModels />,
      },
      {
        path: "events",
        spacesAccess: "hidden-from-limited-view",
        element: <EventModels />,
      },
    ],
  },
  {
    path: "schema",
    spacesAccess: "accessible-from-limited-view",
    element: <Navigate to="/schema/parent-models" replace />,
  },
  {
    path: "schema-v2/*",
    spacesAccess: "accessible-from-limited-view",
    element: <SchemaPage />,
  },
  {
    path: "schema-v2/settings/sync-templates/*",
    spacesAccess: "hidden-from-limited-view",
    element: <RedirectWithWildcard path="/templates/sync-templates" />,
  },
];
